import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography, Alert, CircularProgress } from "@mui/material";
import { getAxios } from "@coremind/identity-core";
const STATUS_COPY = {
    received: "Your data deletion request has been received and is queued for processing.",
    processing: "Your data deletion request is currently being processed.",
    completed: "Your data has been deleted.",
};
// Facebook's Data Deletion Request Callback (app/v1/routes/facebook_data_deletion.py) returns a
// status URL shaped like https://www.offsetmind.com/legal/data-deletion?id=<confirmation_code> --
// this page is that URL's destination, showing the user their request landed.
export default function DataDeletionStatusPage() {
    const [searchParams] = useSearchParams();
    const confirmationCode = searchParams.get("id");
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!confirmationCode) {
            setError("Missing confirmation code.");
            setLoading(false);
            return;
        }
        getAxios()
            .get(`/public/facebook/data-deletion/${encodeURIComponent(confirmationCode)}`)
            .then((res) => setStatus(res.data))
            .catch(() => setError("We couldn't find a deletion request with that confirmation code."))
            .finally(() => setLoading(false));
    }, [confirmationCode]);
    return (_jsxs(Box, { sx: { maxWidth: 560, mx: "auto", px: 3, py: 8 }, children: [_jsx(Typography, { variant: "h4", fontWeight: 800, sx: { mb: 3 }, children: "Data Deletion Request" }), loading && _jsx(CircularProgress, { size: 24 }), !loading && error && _jsx(Alert, { severity: "error", children: error }), !loading && status && (_jsxs(_Fragment, { children: [_jsx(Alert, { severity: status.status === "completed" ? "success" : "info", sx: { mb: 2 }, children: STATUS_COPY[status.status] }), _jsxs(Typography, { variant: "body2", color: "text.secondary", children: ["Confirmation code: ", status.confirmation_code] }), _jsxs(Typography, { variant: "body2", color: "text.secondary", children: ["Requested: ", new Date(status.requested_at).toLocaleString()] }), status.completed_at && (_jsxs(Typography, { variant: "body2", color: "text.secondary", children: ["Completed: ", new Date(status.completed_at).toLocaleString()] }))] }))] }));
}
